import type { TmsInvoiceStatusGroup, TmsLoadRow, TmsLoadStage } from '@numeo/types-main-web-app'
import { formatCurrency } from '@/utils/formatters'

/** Money as the cards carry it: dollars, cents shown; unknown is a dash, never zero. */
export const formatUsd = (value: number | null | undefined): string => (value === null || value === undefined ? '—' : formatCurrency(value, 2))

/** The Invoices page's tab names for the cards' status groups. */
export const STATUS_GROUP_LABEL: Record<TmsInvoiceStatusGroup, string> = {
    ready_to_invoice: 'Ready to invoice',
    pending: 'Pending',
    invoiced: 'Invoiced',
    funded_by_factor: 'Funded by factor',
    paid_by_broker: 'Paid by broker',
    issues: 'Issues',
}

/** The Ongoing Loads board's tab names for the load stages. */
export const LOAD_STAGE_LABEL: Record<TmsLoadStage, string> = {
    upcoming: 'Upcoming',
    dispatched: 'Dispatched',
    in_transit: 'In transit',
    delivered: 'Delivered',
    cancelled: 'Cancelled',
}

/** A load's lane, from what the card knows of it. */
export const laneOf = (origin: string | null, destination: string | null): string => [origin ?? '?', destination ?? '?'].join(' → ')

/** A delivered load's invoice cell: its invoice number, "Invoiced" when the number is unknown, else "Not invoiced". */
export const invoiceCellOf = (row: TmsLoadRow): string => {
    if (row.status !== 'delivered') return '—'
    if (!row.invoice) return 'Not invoiced'
    return row.invoice.invoice_number ?? 'Invoiced'
}
